import { storageDateFormat } from '@/core';
import moment from 'moment';

export default function() {
	return {
		trips: [],
		tripsLoading: false,
		searchFilter: {
			etd: {
				from: moment().subtract(7,'d').startOf('day').format(storageDateFormat),
				to: ''
			},
			fromLocation: [],
			toLocation: [],
			tripType: [],
			status: [],
			cargoCarrier: [],
		},
		tripDetails: null,
		loadedSearch: { id:-1, labelKey: 'resetSearch', },
		pollInterval: {},
		liveUpdateInProgress: false
	};
}
